export const openShareWindow = ({ url, width, height }: { url: string; width: number; height: number }): void => {
	const left = window.outerWidth / 2 + (window.screenX || window.screenLeft || 0) - width / 2;
	const top = window.outerHeight / 2 + (window.screenY || window.screenTop || 0) - height / 2;
	window.open(
		url,
		'',
		`menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=${height},width=${width},top=${top},left=${left}`
	);
};

export const openFacebookShareWindow = (url: string): void => {
	openShareWindow({
		url: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
		width: 550,
		height: 400,
	});
};

export const openLinkedinShareWindow = (url: string): void => {
	openShareWindow({
		url: `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(url)}`,
		width: 750,
		height: 600,
	});
};

export const navigatorShare = async (url?: string, text?: string, title?: string): Promise<void> => {
	if (navigator.share) {
		await navigator.share({ title, text, url });
	}
};
